import React, { useState, useEffect } from "react";
import logo from "../assets/logo/logo_header.png";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#services" },
  { label: "Collections", href: "#catalogue" },
  { label: "Reels", href: "#reels" },
  { label: "Contact", href: "#visit" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur shadow-md"
          : "bg-white/85 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-5 md:px-10 py-2 sm:py-2.5">
        <a href="#home" className="flex items-center gap-3 sm:gap-4 min-w-0">
          <img
            src={logo}
            alt="SMS Gold  Shivkumar Jewellers"
            className="h-12 sm:h-14 md:h-16 w-auto object-contain flex-shrink-0"
          />
          <div className="leading-tight min-w-0">
            <div className="font-serif text-maroon text-base sm:text-xl md:text-2xl font-bold truncate">
              Shivkumar Jewellers
            </div>
            <div className="hidden sm:block text-[9px] md:text-xs tracking-[0.25em] md:tracking-[0.3em] text-gold-dark uppercase">
              Since 1933  Visnagar
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="relative font-medium text-maroon hover:text-gold-dark transition-colors after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-0 after:bg-gold after:transition-all hover:after:w-full text-sm xl:text-base"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#visit"
            className="ml-1 inline-flex items-center gap-2 bg-maroon text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-maroon-dark transition-colors shadow-md"
          >
            Visit Store
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-maroon flex-shrink-0"
          aria-label="Toggle menu"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {open ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gold/30 px-6 py-5 flex flex-col gap-4 shadow-lg">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-maroon font-medium hover:text-gold-dark py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#visit"
            onClick={() => setOpen(false)}
            className="bg-maroon text-white text-center px-5 py-2.5 rounded-full font-medium mt-2"
          >
            Visit Store
          </a>
        </div>
      )}
    </header>
  );
}
